import store from 'store';
import { IRBACState } from 'shared/stateManagement/state';
import { RBAC_PERSONA } from 'models/enum';
import { eeEnvVariables } from './constants';
import { TFunction } from 'i18next';
//import { t  } from 'i18next';

const getAppTitleTransKey = (persona: string) => {
  switch (persona) {
    case RBAC_PERSONA.KF_ASSESS_DEMO_USER:
    case RBAC_PERSONA.KF_ASSESS_USER:
      return 'kornFerryAssess';
    case RBAC_PERSONA.HIRING_MANAGER:
      return 'hireByKornFerryNimbleRecruit';
    default:
      return 'kornFerryTechCareer';
  }
};

export const getAppTitle = (t: TFunction): string => {
   
  const rbacConfig: IRBACState = store?.getState()?.rbac;
  const environment = eeEnvVariables.ENVIRONMENT;
  const appTitlePrefix = `${
    environment && environment !== 'prod' ? `[KF1${environment}] ` : ''
  }`;
  //const appTitleTransKey = getAppTitleTransKey(rbacConfig.persona);
  const appTitleTransKey = getAppTitleTransKey('HIRING_MANAGER');
  //const appTitleText = appTitlePrefix + t('hireByKornFerryNimbleRecruit');
   const appTitleText = t('hireByKornFerryNimbleRecruit');

  return appTitleText;
};
